import { UserPermissions } from "@/config/userPermissions";
import UserSubscription from "@/models/users/subscriptions/userSubscription";
import { UserService } from "@/services/users/usersService";

export const userSubscriptions = {
  namespaced: true,
  
  actions: {
     async getUserSubscriptions(): Promise<UserSubscription[]> {
          const email = UserPermissions.getCurrentEmail();

          if (!email) {
               return [];
          }

          const userSubscriptions = await UserService.getUserSubscriptions(email);

          return userSubscriptions.items
     },
  },
};

export default userSubscriptions;